import React, { useRef } from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import {
  InputPhoneComponent,
  InputTextComponent,
  SelectComponent
} from 'recupero-comunes'
import { Card, InputGroup } from 'react-bootstrap'
import InputTextRut from '../../../utils/inputTextRut'
import InputText from '../../../utils/inputText'

const FormDrive = ({
  data,
  form,
  initialValues,
  comunaConductor,
  setComunaConductor
}) => {
  const selects = ['cbPhone', 'cbMovil', 'cbComune']

  const refs = useRef(selects.map(() => React.createRef()))

  return (
    <div>
      <Card.Body className='m-2 border border-1 border border-light'>
        <Card.Header
          className='row'
          style={{ background: 'gray', color: 'white' }}
        >
          {form?.formLabel['gestcasos-editimpl-title-cond']}
        </Card.Header>
        <Row className='mt-4'>
          <Col md='3'>
            <InputTextRut
              name='conductorIM.rut'
              type='type'
              label={form?.formLabel['gestcasos-editimpl-rutprop']}
            />
          </Col>
          <Col md='3'>
            <InputText
              name='conductorIM.nombre'
              type='text'
              label={form?.formLabel['gestcasos-editimpl-nomprop']}
            />
          </Col>
          <Col md='3'>
            <InputTextComponent
              name='conductorIM.direccion'
              type='text'
              label={form?.formLabel['gestcasos-editimpl-dirprop']}
            />
          </Col>
          <Col md='3'>
            <InputTextComponent
              name='conductorIM.email'
              type='text'
              label={form?.formLabel['gestcasos-editimpl-emailimpl']}
            />
          </Col>
        </Row>
        <Row className='mt-3'>
          <Col md='3'>
            <InputGroup.Text className='bg-white'>
              <Col sm={6}>
                {data?.cbComune?.length > 0 ? (
                  <InputPhoneComponent
                    ref={refs.current[selects.indexOf('cbPhone')]}
                    name='conductorIM.paisFono'
                    label={form?.formLabel['gestcasos-editimpl-fonocond']}
                    defaultInputValue={
                      data.cbCountry.find(
                        (element) =>
                          element?.nombre === initialValues.conductorIM.paisFono
                      )?.nombre
                    }
                    labelKey='nombre'
                    options={data.cbCountry ? data.cbCountry : []}
                  />
                ) : null}
              </Col>
              <Col sm={6} className='mt-2'>
                <InputTextComponent
                  name='conductorIM.fono'
                  type='text'
                  maxLength='9'
                />
              </Col>
            </InputGroup.Text>
          </Col>
          <Col md='3'>
            <InputGroup.Text className='bg-white'>
              <Col sm={6}>
                {data?.cbComune?.length > 0 ? (
                  <InputPhoneComponent
                    ref={refs.current[selects.indexOf('cbMovil')]}
                    name='conductorIM.paisMovil'
                    label={form?.formLabel['gestcasos-editimpl-movilcond']}
                    defaultInputValue={
                      data.cbCountry.find(
                        (element) =>
                          element?.nombre ===
                          initialValues.conductorIM.paisMovil
                      )?.nombre
                    }
                    labelKey='nombre'
                    options={data.cbCountry ? data.cbCountry : []}
                  />
                ) : null}
              </Col>
              <Col sm={6} className='mt-2'>
                <InputTextComponent
                  name='conductorIM.movil'
                  type='text'
                  maxLength='9'
                />
              </Col>
            </InputGroup.Text>
          </Col>
          <Col md='3'>
            {data.cbComune.length > 0 ? (
              <SelectComponent
                ref={refs.current[selects.indexOf('cbComune')]}
                name='conductorIM.comuna'
                label={form?.formLabel['gestcasoseditimpl-comunaimpl']}
                defaultInputValue={
                  data.cbComune.find((element) =>
                    element?.id.includes(initialValues.conductorIM.comuna)
                  )?.nombre
                }
                onChange={(e) =>
                  setComunaConductor(
                    e
                      ? data?.cbComune.find((element) =>
                          element?.id.includes(e[0].id)
                        )?.atr4
                      : ''
                  )
                }
                labelKey='nombre'
                options={data.cbComune ? data.cbComune : []}
              />
            ) : null}
          </Col>
          <Col md='3'>
            <div>
              <dt className='text-sm font-medium text-gray-500'>
                {form?.formLabel['gestcasos-editimpl-ciudadcond']}
              </dt>
              <dd className='mt-1 text-sm text-gray-900 ml-5'>
                {comunaConductor}
              </dd>
            </div>
          </Col>
        </Row>
      </Card.Body>
    </div>
  )
}

export default FormDrive
